// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"009da2bb","618":"34892515"}[chunkId] + ".chunk.js";
};